import React,{useState,useEffect} from 'react'
import {List,ListItem ,ListItemText //,ListItemIcon
        ,Divider,Collapse ,Typography  } from '@material-ui/core';
/* import InboxIcon from '@material-ui/icons/MoveToInbox';
import BuildIcon from '@material-ui/icons/Build'; */
import {//DirectionsTransitIcon,
        ExpandLess,ExpandMore  } from '@material-ui/icons';
import { makeStyles } from '@material-ui/core/styles';
import { useHistory } from "react-router-dom";
import {findNumberCad} from '../funciones/FindNumber'
import {GeneralesContext} from '../context/GeneralesContext'
const useStyles = makeStyles((theme) => ({
    root: {
      width: '100%',
      maxWidth: 360,
      backgroundColor: theme.palette.background.paper,
      
    },
    nested: {
      paddingLeft: theme.spacing(4),
       "&:hover": {
            backgroundColor:"#696665"
        },
        "&.Mui-selected": {
            backgroundColor:"#696665"
        } 
      
    },
    
    nested2: {      
       "&:hover": {
            backgroundColor:"#696665"
        },
        "&.Mui-selected": {
            backgroundColor:"#696665"
        } 
      
    },
  }));

const Listas = ({funcionAbrir}) => {
    let history = useHistory();
    const classes = useStyles();
    const [open, setOpen] = useState(false);
    const [open2, setOpen2] = useState(false);
    const [open3, setOpen3] = useState(false);
    const [open4, setOpen4] = useState(false);
    const [open5, setOpen5] = useState(false);
    const [open6, setOpen6] = useState(false);
    const [cadena, setCadena] = useState("");
    const [selectedIndex, setSelectedIndex] = useState("");
    let idTipo = localStorage.getItem('Tipo');
    const {generales}=React.useContext(GeneralesContext);

    useEffect(() => {
        let str = localStorage.getItem("UserOperacion");
        if ((str===null ||str===undefined) && generales.userOperacion) 
        {
            setCadena(generales.userOperacion+"|")
          
        }else{
            setCadena(str+"|")
          
        }
      
    }, [generales])
    
    const cambiar = (opcion) => {
        switch (opcion) {
            case 1:
                setOpen(!open);    
                break;
            case 2:
                setOpen2(!open2);    
                break;
            case 3:
                setOpen3(!open3);    
                break;
            case 4:
                setOpen4(!open4);    
                break;  
            case 5:
                setOpen5(!open5);    
                break;   
            case 6:
                setOpen6(!open6);    
                break;                
            default:
                break;
        }              
        
    };

    const nuevaVentana =(elLink)=>{    
        //funcionAbrir()
        setSelectedIndex(elLink);
        history.push(elLink)	
    }

    const contacto=(e)=> {
        e.preventDefault()
        window.open("https://daduva.mx");
    }

    const ItemLista = (link, descripcion) => {
        
        return (
        <ListItem button className={classes.nested}
          onClick={() => nuevaVentana(link)}
          selected={selectedIndex === link}    
        >
          <ListItemText
            secondary={
              <Typography variant="body1" style={{ color: "white" }}>
                {descripcion}
              </Typography>
            }
          />
        </ListItem>
        );
      };
    

    return (
        <div>
            <List component='nav'>         
                <ListItem button onClick={()=>nuevaVentana("/inicio")}  className={classes.nested2} selected={selectedIndex === "/inicio"}  >                    
                    <ListItemText primary="Inicio" />                    
                </ListItem>       
                <ListItem button onClick={()=>nuevaVentana("/tablero")} className={classes.nested2} selected={selectedIndex === "/tablero"}  >                    
                    {findNumberCad('|56|',cadena) ? <ListItemText primary="Tablero" />:null}                    
                </ListItem>
                <ListItem button onClick={()=>nuevaVentana("/renta-maquinaria")} className={classes.nested2} selected={selectedIndex === "/renta-maquinaria"}  >                    
                    {findNumberCad('|51|',cadena) ? <ListItemText primary="Renta de Maquinaria" />:null}                    
                </ListItem>
                <ListItem button onClick={()=>cambiar(2)}>                    
                    <ListItemText primary="Maquinaria" />
                    {open2 ? <ExpandLess /> : <ExpandMore />}
                </ListItem>
              
                <Collapse in={open2} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>                        
                        {findNumberCad('|29|',cadena)  ? ItemLista("/bitacora", "Bitácora"): null }                      
                        {findNumberCad('|39|',cadena)  ? ItemLista("/seguro", "Seguro"): null }     
                        
                    </List>
                </Collapse>
                <ListItem button onClick={()=>cambiar(3)}>                    
                    <ListItemText primary="Catálogos" />
                    {open3 ? <ExpandLess /> : <ExpandMore />}
                </ListItem>
                <Collapse in={open3} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>                        
                        {findNumberCad('|6|',cadena)   ? ItemLista("/catalogo-maquinaria", "Maquinaria"): null }                                          
                        {findNumberCad('|57|',cadena)  ? ItemLista("/catalogo-ubicacion", "Ubicación"): null }     
                        {findNumberCad('|20|',cadena)  ? ItemLista("/catalogo-marca", "Marca"): null }     
                        {findNumberCad('|19|',cadena)  ? ItemLista("/catalogo-refaccion", "Refacción"): null }                             
                        {findNumberCad('|58|',cadena)  ? ItemLista("/catalogo-proveedor", "Proveedor"): null }
                    </List>
                </Collapse>
                <ListItem button onClick={()=>cambiar(4)}>                    
                    <ListItemText primary="Reportes" />
                    {open4 ? <ExpandLess /> : <ExpandMore />}
                </ListItem>
                <Collapse in={open4} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>                        
                        {findNumberCad('|11|',cadena)  ? ItemLista("/reporte-bitacora", "Bitacora"): null }       
                        {findNumberCad('|12|',cadena) ? ItemLista("/reporte-incidencia", "Incidencia"): null }                      
                            
                    </List>
                </Collapse>
                <ListItem button onClick={()=>nuevaVentana("/vigilancia")} className={classes.nested2} selected={selectedIndex === "/vigilancia"} >                    
                    {findNumberCad('|46|',cadena) ? <ListItemText primary="Vigilancia" />:null}                    
                </ListItem>
                <ListItem button onClick={()=>nuevaVentana("/usuarios")} className={classes.nested2} selected={selectedIndex === "/usuarios"}>                    
                    {findNumberCad('0|',cadena) ? <ListItemText primary="Usuarios" />:null}                    
                </ListItem>
               {/*  <Divider/>
                    <ListItem button onClick={()=>cambiar(2)}>                    
                    <ListItemText primary="Sistema" />
                    {open2 ? <ExpandLess /> : <ExpandMore />}
                </ListItem>
             <Collapse in={open2} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>           
                    
                 
                    { ItemLista("/catalogo-usuarios", "Usuarios")  }    
                    
                </List>
            </Collapse> */}
            <Divider/>
           
         
                <ListItem button onClick={contacto} >                    
                    <ListItemText primary="Contacto" />                    
                </ListItem>
            </List>
        </div>
    )
}

export default Listas
